/*
 * All You Can Play - menu dei giochi da telefono e tablet, nel menu a tendina di Dawn (sotto i 990 px).
 * Lo carica snippets/aycp-menu-giochi.liquid; aspetto in assets/aycp-menu-telefono.css. Il file di Dawn del menu
 * (snippets/header-drawer.liquid) e il menu del negozio non cambiano: questo script arricchisce quello che c'è.
 * - Sotto "TCGs" i giochi diventano riquadri con il logo, il nome e quanti prodotti hanno, nell'ordine
 *   della banda da computer. I dati sono quelli del menu da computer (snippets/aycp-menu-giochi.liquid,
 *   blocco [data-aycp-mg-data]): giochi, loghi, tipologie e testi in italiano e inglese.
 * - Toccando un gioco si apre il suo pannello: "Tutti i prodotti (n)", Tipologia con i numeri, Set dal più recente
 *   con le copertine 2 per riga (i primi 6 e "Mostra tutti i n set"), con "Preordine" ed "Esaurito".
 *   I dati arrivano da sections/aycp-menu-pannello.liquid la prima volta che si tocca il gioco e restano
 *   15 minuti nella visita (sessionStorage, la stessa memoria del menu da computer).
 * - Se i dati non arrivano resta l'elenco di Dawn (Tutti i prodotti, Box, Bustine...).
 * - Sotto "Giochi da tavolo": "Tutti i giochi da tavolo (n)" e i giochi con il logo, il nome e quanti prodotti hanno;
 *   toccando un gioco si apre il suo pannello (creato qui, con le classi dei sottomenu di Dawn): "Tutti i prodotti (n)"
 *   e i prodotti 2 per riga, prima i disponibili, con il titolo senza l'editore. Dati del menu da computer
 *   (blocco "x"), prodotti da sections/aycp-menu-prodotti.liquid quando si tocca la voce, tenuti 15 minuti come lì.
 * - Sotto "Altri Prodotti": il buono regalo con la sua immagine e il prezzo; le collezioni (Accessori) con una foto
 *   e il numero di prodotti, e nel loro pannello "Tutti i prodotti (n)", Tipologia con i numeri e 4 disponibili.
 * - Se i prodotti non arrivano resta l'elenco di Dawn di quelle voci.
 * Da 990 px in su il menu a tendina non si vede e lo script non cambia niente di visibile.
 */
(function () {
  'use strict';

  var SETS_SHOWN = 6;
  var PRODUCTS_SHOWN = 10;
  var AVAILABLE_SHOWN = 4;
  var TTL = 15 * 60 * 1000;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function pathOf(href) {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '');
    } catch (e) {
      return '';
    }
  }

  function start() {
    var root = document.querySelector('[data-aycp-mg]');
    if (!root || root.hasAttribute('data-aycp-mt-ready')) return;
    var dataEl = root.querySelector('[data-aycp-mg-data]');
    if (!dataEl) return;
    var cfg;
    try {
      cfg = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var S = cfg && cfg.s ? cfg.s : {};
    root.setAttribute('data-aycp-mt-ready', '');
    var themeId = window.Shopify && window.Shopify.theme && window.Shopify.theme.id ? window.Shopify.theme.id : '';
    var storeKey = 'aycp-mg-v1:' + themeId + ':' + cfg.root + ':';
    tcgs(root, cfg, S, storeKey);
    extras(cfg, S, storeKey);
  }

  /* ========== TCGs ========== */
  function tcgs(root, cfg, S, storeKey) {
    var games = cfg && cfg.games ? cfg.games : [];
    if (!games.length) return;

    // la voce "TCGs" nel menu a tendina: stesso handle della voce del menu da computer (data-tcgs="HeaderMenu-<handle>")
    var handle = (root.getAttribute('data-tcgs') || '').replace(/^HeaderMenu-/, '');
    var summary = handle ? document.getElementById('HeaderDrawer-' + handle) : null;
    var submenu = summary ? document.getElementById(summary.getAttribute('aria-controls')) : null;
    var list = submenu ? submenu.querySelector('.menu-drawer__menu') : null;
    if (!list) return;

    // "99 prodotti" già tradotto, dalla colonna dei giochi del pannello TCGs da computer (stesso ordine dei giochi)
    var counts = Array.prototype.map.call(root.querySelectorAll('[data-aycp-tcgs-panel] .aycp-mg__rail-game .aycp-mg__n'), function (el) {
      return el.textContent.replace(/\s+/g, ' ').trim();
    });

    var memory = {};
    var loaded = {};

    function load(i) {
      var g = games[i];
      if (memory[g.h]) return memory[g.h];
      try {
        var raw = window.sessionStorage.getItem(storeKey + g.h);
        if (raw) {
          var saved = JSON.parse(raw);
          if (saved && saved.d && Date.now() - saved.at < TTL) {
            loaded[g.h] = saved.d;
            memory[g.h] = Promise.resolve(saved.d);
            return memory[g.h];
          }
        }
      } catch (e) {
        /* senza sessionStorage si richiede ogni volta */
      }
      var url = g.u + (g.u.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(cfg.section);
      memory[g.h] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var script = doc.querySelector('[data-aycp-panel]');
          var d = script ? JSON.parse(script.textContent) : null;
          if (!d || !d.sets) throw new Error('vuoto');
          loaded[g.h] = d;
          try {
            window.sessionStorage.setItem(storeKey + g.h, JSON.stringify({ at: Date.now(), d: d }));
          } catch (e) {
            /* spazio pieno o non disponibile: va bene lo stesso */
          }
          return d;
        });
      memory[g.h].catch(function () {
        delete memory[g.h];
      });
      return memory[g.h];
    }

    /* ---------- i giochi sotto "TCGs": logo, nome e numero di prodotti ---------- */
    var items = Array.prototype.slice.call(list.children);
    var byGame = [];
    items.forEach(function (li) {
      var details = li.querySelector(':scope > details');
      if (!details) return;
      var child = details.querySelector(':scope > .menu-drawer__submenu');
      var links = child ? child.querySelectorAll('a[href]') : [];
      var paths = Array.prototype.map.call(links, function (a) {
        return pathOf(a.getAttribute('href'));
      });
      for (var i = 0; i < games.length; i++) {
        if (byGame[i]) continue;
        if (paths.indexOf(pathOf(games[i].u)) !== -1) {
          byGame[i] = { li: li, details: details, child: child };
          break;
        }
      }
    });

    // ordine della banda da computer; le voci senza gioco riconosciuto restano in fondo, come sono
    byGame.forEach(function (entry) {
      if (entry) list.appendChild(entry.li);
    });
    items.forEach(function (li) {
      var known = byGame.some(function (entry) {
        return entry && entry.li === li;
      });
      if (!known) list.appendChild(li);
    });

    byGame.forEach(function (entry, i) {
      if (!entry) return;
      var g = games[i];
      var sum = entry.details.querySelector(':scope > summary');
      if (!sum) return;
      var name = '';
      Array.prototype.slice.call(sum.childNodes).forEach(function (node) {
        if (node.nodeType === 3) {
          name += node.textContent;
          sum.removeChild(node);
        }
      });
      name = name.replace(/\s+/g, ' ').trim() || g.t;
      var blue = g.logo && g.logo.indexOf('-su-blu') !== -1;
      var logo = document.createElement('span');
      logo.className = 'aycp-mt__logo' + (blue ? ' aycp-mt__logo--blu' : '');
      logo.innerHTML = g.logo ? '<img src="' + esc(g.logo) + '" alt="" loading="lazy">' : '<span class="aycp-mt__logo-name">' + esc(g.t) + '</span>';
      var text = document.createElement('span');
      text.className = 'aycp-mt__name';
      text.innerHTML = esc(name) + (counts[i] ? '<span class="aycp-mt__n">' + esc(counts[i]) + '</span>' : '');
      sum.insertBefore(text, sum.firstChild);
      sum.insertBefore(logo, sum.firstChild);
      sum.classList.add('aycp-mt__game');

      // il pannello si prepara al tocco, prima che la tendina scorra
      sum.addEventListener('click', function () {
        if (!entry.details.hasAttribute('open')) open(i);
      });
      entry.details.addEventListener('toggle', function () {
        if (entry.details.hasAttribute('open')) open(i);
      });
    });
    list.classList.add('aycp-mt__games');

    /* ---------- pannello di un gioco ---------- */
    var expanded = {};

    function typesOf(g, d) {
      return (g.types || [])
        .map(function (t) {
          return { l: t.l, u: t.u, n: d && d.tags ? d.tags[t.g] || 0 : null };
        })
        .filter(function (t) {
          return t.n === null || t.n > 0;
        });
    }

    function badge(s) {
      if (s.p) return '<span class="aycp-mt__badge aycp-mt__badge--pre">' + esc(S.pre) + '</span>';
      if (!s.b) {
        return S.soldOut
          ? '<span class="aycp-mt__badge badge ' + esc(S.soldOutClass || '') + '">' + esc(S.soldOut) + '</span>'
          : '<span class="aycp-mt__badge aycp-mt__badge--out">' + esc(S.out) + '</span>';
      }
      return '';
    }

    // "Mostra tutti i [n] set"; in italiano davanti a 8, 11, 80... si scrive "gli" (gli 8 set, gli 11 set)
    function showAll(n) {
      var text = String(S.showAllSets || '');
      if (/^8|^11$/.test(String(n))) text = text.replace('tutti i [n]', 'tutti gli [n]');
      return text.replace('[n]', n);
    }

    function setTile(s) {
      var label = (s.c ? s.c + ' ' : '') + s.t;
      var picture = s.i
        ? '<img src="' + esc(s.i) + '" alt="" loading="lazy">'
        : '<span class="aycp-mt__plain">' + esc(s.c || s.t) + '</span>';
      return (
        '<a class="aycp-mt__set' + (s.b ? '' : ' is-out') + '" href="' + esc(s.u) + '">' +
        '<span class="aycp-mt__cover">' + picture + badge(s) + '</span>' +
        '<span class="aycp-mt__set-t">' + esc(label) + '</span>' +
        '</a>'
      );
    }

    function panelHtml(i) {
      var g = games[i];
      var d = loaded[g.h] || null;
      var n = d ? d.n : g.n;
      var types = typesOf(g, d);
      var html =
        '<a class="aycp-mt__all" href="' + esc(g.u) + '"><span>' + esc(S.allProducts) + ' (' + n + ')</span>' +
        '<span aria-hidden="true">→</span></a>';
      if (types.length) {
        html +=
          '<div class="aycp-mt__h">' + esc(S.types) + '</div><div class="aycp-mt__chips">' +
          types
            .map(function (t) {
              return '<a class="aycp-mt__chip" href="' + esc(t.u) + '">' + esc(t.l) + (t.n === null ? '' : ' <span class="aycp-mt__n">' + t.n + '</span>') + '</a>';
            })
            .join('') +
          '</div>';
      }
      if (!d) {
        html += '<p class="aycp-mt__msg">' + esc(S.loading) + '</p>';
      } else if (d.sets.length) {
        var all = expanded[g.h] === true;
        var sets = all ? d.sets : d.sets.slice(0, SETS_SHOWN);
        html += '<div class="aycp-mt__h">' + esc(S.sets) + '</div><div class="aycp-mt__sets">' + sets.map(setTile).join('') + '</div>';
        if (!all && d.sets.length > SETS_SHOWN) {
          html += '<button class="aycp-mt__more" type="button" data-aycp-mt-more>' + esc(showAll(d.sets.length)) + '</button>';
        }
      }
      return html;
    }

    function render(i) {
      var entry = byGame[i];
      var panel = entry.child.querySelector(':scope > .aycp-mt__panel');
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'aycp-mt__panel';
        var back = entry.child.querySelector(':scope > .menu-drawer__close-button');
        if (back) back.insertAdjacentElement('afterend', panel);
        else entry.child.insertBefore(panel, entry.child.firstChild);
        panel.addEventListener('click', function (event) {
          if (!event.target.closest('[data-aycp-mt-more]')) return;
          event.preventDefault();
          expanded[games[i].h] = true;
          render(i);
        });
      }
      panel.innerHTML = panelHtml(i);
      entry.child.classList.add('aycp-mt-on');
    }

    function fallback(i) {
      // senza dati resta l'elenco di Dawn, com'era
      var entry = byGame[i];
      var panel = entry.child.querySelector(':scope > .aycp-mt__panel');
      if (panel) panel.remove();
      entry.child.classList.remove('aycp-mt-on');
    }

    function open(i) {
      render(i);
      if (loaded[games[i].h]) return;
      load(i).then(
        function () {
          render(i);
        },
        function () {
          fallback(i);
        }
      );
    }
  }

  /* ========== Giochi da tavolo e Altri Prodotti ========== */
  function extras(cfg, S, storeKey) {
    var entries = cfg && cfg.x ? cfg.x : [];
    if (!entries.length || !cfg.xsection) return;
    var memory = {};
    var loaded = {};

    function norm(value) {
      return String(value == null ? '' : value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    // prodotti di una collezione (sections/aycp-menu-prodotti.liquid), nella stessa memoria del menu da computer
    function load(h, u) {
      if (memory[h]) return memory[h];
      var key = storeKey + 'p:' + h;
      try {
        var raw = window.sessionStorage.getItem(key);
        if (raw) {
          var saved = JSON.parse(raw);
          if (saved && saved.d && Date.now() - saved.at < TTL) {
            loaded[h] = saved.d;
            memory[h] = Promise.resolve(saved.d);
            return memory[h];
          }
        }
      } catch (e) {
        /* senza sessionStorage si richiede ogni volta */
      }
      var url = u + (u.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(cfg.xsection);
      memory[h] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var script = doc.querySelector('[data-aycp-prods]');
          var d = script ? JSON.parse(script.textContent) : null;
          if (!d || !d.p) throw new Error('vuoto');
          d.p.forEach(function (p) {
            p.g = (p.g || []).map(norm);
          });
          loaded[h] = d;
          try {
            window.sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), d: d }));
          } catch (e) {
            /* spazio pieno o non disponibile: va bene lo stesso */
          }
          return d;
        });
      memory[h].catch(function () {
        delete memory[h];
      });
      return memory[h];
    }

    function withTag(items, tag) {
      return items.filter(function (p) {
        return p.g.indexOf(tag) !== -1;
      });
    }

    // prima i disponibili, poi dal prezzo più alto (come il menu da computer)
    function byAvailability(items) {
      return items.slice().sort(function (a, b) {
        return (b.b ? 1 : 0) - (a.b ? 1 : 0) || (b.v || 0) - (a.v || 0);
      });
    }

    // "Ravensburger - Villainous ..." diventa "Villainous ...": il gioco è già scritto in alto
    function withoutPublisher(title) {
      var i = title.indexOf(' - ');
      return i > 0 && i <= 30 ? title.slice(i + 3) : title;
    }

    function nProducts(n) {
      return n + ' ' + (n === 1 ? S.product1 : S.productN);
    }

    function allButton(u, label, n) {
      return (
        '<a class="aycp-mt__all" href="' + esc(u) + '"><span>' + esc(label) + (n == null ? '' : ' (' + n + ')') + '</span>' +
        '<span aria-hidden="true">→</span></a>'
      );
    }

    function waiting(h) {
      return '<p class="aycp-mt__msg">' + esc(memory[h] ? S.loading : S.error) + '</p>';
    }

    function soldOut() {
      return S.soldOut
        ? '<span class="aycp-mt__badge badge ' + esc(S.soldOutClass || '') + '">' + esc(S.soldOut) + '</span>'
        : '<span class="aycp-mt__badge aycp-mt__badge--out">' + esc(S.out) + '</span>';
    }

    function cards(items, strip) {
      return (
        '<div class="aycp-mt__prods">' +
        items
          .map(function (p) {
            return (
              '<a class="aycp-mt__prod" href="' + esc(p.u) + '"><span class="aycp-mt__prod-img">' +
              (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : '') + (p.b === false ? soldOut() : '') + '</span>' +
              '<span class="aycp-mt__prod-t">' + esc(strip ? withoutPublisher(p.t) : p.t) + '</span>' +
              '<span class="aycp-mt__prod-p">' + esc(p.pr) + '</span></a>'
            );
          })
          .join('') +
        '</div>'
      );
    }

    // toglie e restituisce il testo di Dawn di una voce (il nome tradotto del menu)
    function takeText(element) {
      var text = '';
      Array.prototype.slice.call(element.childNodes).forEach(function (node) {
        if (node.nodeType === 3) {
          text += node.textContent;
          element.removeChild(node);
        }
      });
      return text.replace(/\s+/g, ' ').trim();
    }

    // sottomenu creato qui, aperto e chiuso come quelli di Dawn (classi menu-opening e submenu-open, stessa animazione);
    // Esc e la chiusura del menu li gestisce già Dawn
    function submenu(details, onOpen) {
      var summary = details.querySelector(':scope > summary');
      var box = details.querySelector(':scope > .menu-drawer__submenu');
      var back = box.querySelector(':scope > .menu-drawer__close-button');
      var parent = details.parentElement.closest('.has-submenu');
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.hasAttribute('open')) return;
        details.setAttribute('open', '');
        onOpen();
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            details.classList.add('menu-opening');
            summary.setAttribute('aria-expanded', 'true');
            if (parent) parent.classList.add('submenu-open');
            back.focus({ preventScroll: true });
          });
        });
      });
      back.addEventListener('click', function (event) {
        event.preventDefault();
        details.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
        if (parent) parent.classList.remove('submenu-open');
        summary.focus({ preventScroll: true });
        window.setTimeout(function () {
          if (!details.classList.contains('menu-opening')) details.removeAttribute('open');
        }, 400);
      });
    }

    function logo(g) {
      if (!g.logo) return '<span class="aycp-mt__logo-name">' + esc(g.l) + '</span>';
      return '<img src="' + esc(g.logo) + '" alt="" loading="lazy"' + (g.s && g.s !== 100 ? ' style="transform: scale(' + g.s / 100 + ')"' : '') + '>';
    }

    /* ---------- Giochi da tavolo ---------- */
    function boardGames(x, summary, inner) {
      var dawnList = inner.querySelector(':scope > .menu-drawer__menu');
      var back = inner.querySelector(':scope > .menu-drawer__close-button');
      if (!dawnList || !back) return;
      var arrows = Array.prototype.map.call(summary.querySelectorAll(':scope > .svg-wrapper'), function (el) {
        return el.outerHTML;
      }).join('');
      var backIcon = back.querySelector('.svg-wrapper') ? back.querySelector('.svg-wrapper').outerHTML : '';
      var box = document.createElement('div');
      box.className = 'aycp-mt__list';
      box.innerHTML =
        '<div class="aycp-mt__list-top">' + allButton(x.u, S.allBoardGames, x.n) + '</div>' +
        '<ul class="menu-drawer__menu list-menu aycp-mt__games" role="list">' +
        x.games
          .map(function (g) {
            return (
              '<li><details><summary class="menu-drawer__menu-item list-menu__item link link--text focus-inset aycp-mt__game" role="button" aria-expanded="false">' +
              '<span class="aycp-mt__logo">' + logo(g) + '</span><span class="aycp-mt__name">' + esc(g.l) + '<span class="aycp-mt__n"></span></span>' + arrows +
              '</summary><div class="menu-drawer__submenu has-submenu gradient motion-reduce" tabindex="-1">' +
              '<button type="button" class="menu-drawer__close-button link link--text focus-inset" aria-expanded="true">' + backIcon + esc(g.l) + '</button>' +
              '<div class="aycp-mt__panel"></div></div></details></li>'
            );
          })
          .join('') +
        '</ul>';
      back.insertAdjacentElement('afterend', box);
      inner.classList.add('aycp-mt-on');
      var rows = Array.prototype.slice.call(box.querySelectorAll('.aycp-mt__games > li > details'));

      function counts() {
        var d = loaded[x.h];
        if (!d) return;
        rows.forEach(function (details, k) {
          details.querySelector('.aycp-mt__n').textContent = nProducts(withTag(d.p, x.games[k].g).length);
        });
        box.querySelector('.aycp-mt__list-top .aycp-mt__all span').textContent = S.allBoardGames + ' (' + d.n + ')';
      }

      function panel(k) {
        var d = loaded[x.h];
        var target = rows[k].querySelector('.aycp-mt__panel');
        if (!d) {
          target.innerHTML = waiting(x.h);
          return;
        }
        var g = x.games[k];
        var items = byAvailability(withTag(d.p, g.g));
        target.innerHTML = allButton(g.u, S.allProducts, items.length) + cards(items.slice(0, PRODUCTS_SHOWN), true);
      }

      function fallback() {
        // senza prodotti resta l'elenco di Dawn
        box.remove();
        inner.classList.remove('aycp-mt-on');
        var sub = inner.closest('.menu-drawer__submenu');
        if (sub) sub.classList.remove('submenu-open');
      }

      function get() {
        if (loaded[x.h]) return;
        load(x.h, x.u).then(function () {
          counts();
          rows.forEach(function (details, k) {
            if (details.hasAttribute('open')) panel(k);
          });
        }, fallback);
      }

      rows.forEach(function (details, k) {
        submenu(details, function () {
          get();
          panel(k);
        });
      });
      // i prodotti partono quando si tocca "Giochi da tavolo"
      summary.addEventListener('click', get);
      counts();
    }

    /* ---------- Altri Prodotti ---------- */
    function giftRow(link, c) {
      var name = takeText(link) || c.l;
      link.innerHTML =
        '<span class="aycp-mt__logo aycp-mt__logo--photo">' + (c.i ? '<img src="' + esc(c.i) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="aycp-mt__name">' + esc(name) + (c.pr ? '<span class="aycp-mt__n">' + esc(c.pr) + '</span>' : '') + '</span>';
      link.classList.add('aycp-mt__game');
    }

    function collectionRow(details, child, c) {
      var summary = details.querySelector(':scope > summary');
      var name = takeText(summary) || c.l;
      var tile = document.createElement('span');
      tile.className = 'aycp-mt__logo';
      tile.innerHTML = '<span class="aycp-mt__logo-name">' + esc(name) + '</span>';
      var text = document.createElement('span');
      text.className = 'aycp-mt__name';
      text.innerHTML = esc(name) + '<span class="aycp-mt__n">' + esc(nProducts(c.n)) + '</span>';
      summary.insertBefore(text, summary.firstChild);
      summary.insertBefore(tile, summary.firstChild);
      summary.classList.add('aycp-mt__game');
      var panel = null;

      function row() {
        var d = loaded[c.h];
        if (!d) return;
        var first = byAvailability(d.p)[0];
        if (first && first.i) tile.innerHTML = '<img src="' + esc(first.i) + '" alt="" loading="lazy">';
        text.querySelector('.aycp-mt__n').textContent = nProducts(d.n);
      }

      function fill() {
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'aycp-mt__panel';
          var back = child.querySelector(':scope > .menu-drawer__close-button');
          if (back) back.insertAdjacentElement('afterend', panel);
          else child.insertBefore(panel, child.firstChild);
        }
        var d = loaded[c.h];
        var types = (c.types || [])
          .map(function (t) {
            return { l: t.l, u: t.u, n: d ? withTag(d.p, t.g).length : null };
          })
          .filter(function (t) {
            return t.n === null || t.n > 0;
          });
        var html = allButton(c.u, S.allProducts, d ? d.n : c.n);
        if (types.length) {
          html +=
            '<div class="aycp-mt__h">' + esc(S.types) + '</div><div class="aycp-mt__chips">' +
            types
              .map(function (t) {
                return '<a class="aycp-mt__chip" href="' + esc(t.u) + '">' + esc(t.l) + (t.n === null ? '' : ' <span class="aycp-mt__n">' + t.n + '</span>') + '</a>';
              })
              .join('') +
            '</div>';
        }
        if (!d) {
          html += waiting(c.h);
        } else {
          var available = byAvailability(d.p.filter(function (p) {
            return p.b;
          })).slice(0, AVAILABLE_SHOWN);
          if (available.length) html += '<div class="aycp-mt__h">' + esc(S.available) + '</div>' + cards(available, false);
        }
        panel.innerHTML = html;
        child.classList.add('aycp-mt-on');
      }

      function fallback() {
        // senza prodotti resta l'elenco di Dawn della collezione
        if (panel) panel.remove();
        panel = null;
        child.classList.remove('aycp-mt-on');
      }

      function get() {
        if (loaded[c.h]) return;
        load(c.h, c.u).then(function () {
          row();
          if (details.hasAttribute('open')) fill();
        }, fallback);
      }

      // il pannello si prepara al tocco, prima che la tendina scorra
      summary.addEventListener('click', function () {
        if (details.hasAttribute('open')) return;
        get();
        fill();
      });
      details.addEventListener('toggle', function () {
        if (!details.hasAttribute('open')) return;
        get();
        fill();
      });
      row();
      return get;
    }

    function otherProducts(x, summary, inner) {
      var dawnList = inner.querySelector(':scope > .menu-drawer__menu');
      if (!dawnList) return;
      var getters = [];
      Array.prototype.slice.call(dawnList.children).forEach(function (li) {
        var link = li.querySelector(':scope > a[href]');
        var details = li.querySelector(':scope > details');
        var child = details ? details.querySelector(':scope > .menu-drawer__submenu') : null;
        var paths = child
          ? Array.prototype.map.call(child.querySelectorAll('a[href]'), function (a) {
              return pathOf(a.getAttribute('href'));
            })
          : [];
        (x.cols || []).forEach(function (c) {
          if (c.k === 'p' && link && pathOf(link.getAttribute('href')) === pathOf(c.u)) giftRow(link, c);
          if (c.k === 'c' && child && paths.indexOf(pathOf(c.u)) !== -1) getters.push(collectionRow(details, child, c));
        });
      });
      dawnList.classList.add('aycp-mt__games');
      // le foto e i numeri delle collezioni partono quando si tocca "Altri Prodotti"
      summary.addEventListener('click', function () {
        getters.forEach(function (get) {
          get();
        });
      });
    }

    entries.forEach(function (x) {
      var summary = document.getElementById(String(x.id || '').replace(/^HeaderMenu-/, 'HeaderDrawer-'));
      var sub = summary ? document.getElementById(summary.getAttribute('aria-controls')) : null;
      if (!sub) return;
      var inner = sub.querySelector(':scope > .menu-drawer__inner-submenu') || sub;
      if (x.k === 'bg' && x.games && x.games.length) boardGames(x, summary, inner);
      else if (x.k === 'op') otherProducts(x, summary, inner);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
